import api from '.'
import {
	ContractLoadingSummary,
	ContractSummariesReq,
	ContractSummary,
	ContractSummaryDetail,
	ContractSummaryDetailReq,
} from './contractLoading.types'

export const ContractLoadingKeys = {
	all: (basketId: Id) => ['contract-summaries', basketId],
	contract: (basketId: Id, contractId: Id, query?: ContractSummaryDetailReq | null) => [
		...ContractLoadingKeys.all(basketId),
		contractId,
		query,
	],
	list: (basketId: Id, query?: ContractSummariesReq | null) => [
		...ContractLoadingKeys.all(basketId),
		query,
	],
	summary: (basketId: Id) => [...ContractLoadingKeys.all(basketId), 'summary'],
}

const ContractLoadingApi = {
	contract: (contractId: Id, query: ContractSummaryDetailReq) =>
		api
			.get<APIRes<ContractSummaryDetail>>(`/market-baskets/contract-summaries/${contractId}`, {
				params: { ...query },
			})
			.then((res) => res.data.data),

	list: (basketId: Id, query: ContractSummariesReq) =>
		api
			.get<APIRes<ContractSummary[]>>(`/market-baskets/${basketId}/contract-summaries`, {
				params: { ...query },
			})
			.then((res) => res.data.data),

	summary: (basketId: Id) =>
		api
			.get<APIRes<ContractLoadingSummary>>(`/market-baskets/${basketId}/contract-summaries/summary`)
			.then((res) => res.data.data),

	accept: (contractId: Id) =>
		api.post(`/market-baskets/contract-summaries/${contractId}/accept`).then((res) => res.data),

	reject: (contractId: Id) =>
		api.post(`/market-baskets/contract-summaries/${contractId}/reject`).then((res) => res.data),
}

export default ContractLoadingApi
